// src/hooks/usePersonsFetch.js
import { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';

function PersonsFetch() {
  const [persons, setPersons] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function fetchPersons() {
      setIsLoading(true);
      const querySnapshot = await getDocs(collection(db, "users"));
      const loadedPersons = querySnapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setPersons(loadedPersons);
      setIsLoading(false);
    }

    fetchPersons();
  }, []);

  return { persons, isLoading };
}

export default PersonsFetch;
